import { hotDiscussions } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

const contributors = [
  { name: "拆解机", tag: "技术组", replies: 486, percent: 92 },
  { name: "夜航船", tag: "常驻线人", replies: 372, percent: 78 },
  { name: "南墙不改", tag: "资深爆料人", replies: 265, percent: 61 },
  { name: "路口的风", tag: "常驻线人", replies: 198, percent: 46 },
];

export default function HotDiscussion() {
  return (
    <section id="discussion" className="w-full border-b border-foreground-900 bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionHeading
          light
          icon="ri-chat-smile-2-line"
          eyebrow="热议互动榜 · HOT THREADS"
          title="评论数说话，这几条帖子被顶到了最前面"
          desc="榜单按近 24 小时的讨论量与参与人数排序，评论越密集的帖子越靠前 —— 想知道大家在争论什么，从第一名往下看就行。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.6fr_1fr]">
          <Reveal>
            <div className="flex flex-col gap-3">
              {hotDiscussions.map((item) => (
                <article
                  key={item.rank}
                  className="group flex flex-col gap-4 rounded-lg border border-foreground-800 bg-foreground-900 p-4 transition-colors duration-300 hover:border-accent-500/60 md:flex-row md:items-center md:p-5"
                >
                  <div className="flex items-center gap-4 md:w-[280px] md:shrink-0">
                    <span
                      className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-xl font-bold ${
                        item.rank <= 3
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-foreground-800 text-background-200"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0">
                      <h4 className="font-heading text-base font-bold leading-snug text-background-50">
                        <a href="#comments" className="cursor-pointer transition-colors hover:text-accent-400">
                          {item.title}
                        </a>
                      </h4>
                      <span className="mt-1.5 inline-block rounded-md bg-foreground-800 px-2 py-0.5 text-[11px] text-background-200">
                        #{item.tag}
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-1 items-center gap-3 border-t border-foreground-800 pt-3 md:border-l md:border-t-0 md:pl-5 md:pt-0">
                    <div className="flex -space-x-2">
                      {[0, 1, 2].map((i) => (
                        <span
                          key={i}
                          className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-foreground-900 bg-foreground-800 text-background-200"
                        >
                          <i className="ri-user-3-line text-xs" />
                        </span>
                      ))}
                    </div>
                    <p className="line-clamp-1 flex-1 text-xs italic text-background-200/80">
                      {item.snippet}
                    </p>
                  </div>

                  <div className="flex shrink-0 items-center gap-5 md:flex-col md:items-end md:gap-1">
                    <span className="flex items-baseline gap-1 text-accent-400">
                      <i className="ri-chat-3-fill text-sm" />
                      <span className="font-heading text-lg font-bold">
                        {item.comments.toLocaleString("en-US")}
                      </span>
                    </span>
                    <span className="text-[11px] text-background-200/70">
                      {item.participants.toLocaleString("en-US")} 人参与
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </Reveal>

          <Reveal delay={80}>
            <aside className="flex h-full flex-col rounded-lg border border-foreground-800 bg-foreground-900 p-5">
              <div className="flex items-center justify-between">
                <h4 className="flex items-center gap-2 font-heading text-base font-bold text-background-50">
                  <span className="flex h-5 w-5 items-center justify-center text-accent-400">
                    <i className="ri-medal-line text-lg" />
                  </span>
                  讨论贡献榜
                </h4>
                <span className="text-[11px] text-background-200/70">近 7 天</span>
              </div>

              <div className="mt-5 flex flex-col gap-5">
                {contributors.map((person) => (
                  <div key={person.name}>
                    <div className="flex items-center justify-between text-sm">
                      <span className="flex items-center gap-2 text-background-50">
                        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-500/20 text-primary-300">
                          <i className="ri-user-star-line text-xs" />
                        </span>
                        {person.name}
                        <span className="rounded-md bg-foreground-800 px-1.5 py-0.5 text-[10px] text-background-200">
                          {person.tag}
                        </span>
                      </span>
                      <span className="font-label text-background-200">{person.replies} 条</span>
                    </div>
                    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-foreground-800">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${person.percent}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 rounded-lg border border-foreground-800 bg-foreground-950 p-4">
                <p className="flex items-start gap-2 text-xs leading-relaxed text-background-200/80">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                    <i className="ri-lightbulb-line" />
                  </span>
                  连续参与讨论、被点赞较多的线人，会出现在榜单并按周结算。理性发言，别把可核线索聊成了情绪大战。
                </p>
              </div>
            </aside>
          </Reveal>
        </div>
      </div>
    </section>
  );
}